export const setUserData = ({
  token,
  userProfileRole,
  userProfileData,
  brandProfileData,
  storeData,
  warehouseData,
  garmentCategoryServiceIconsResData,
}) => {
  localStorage.setItem("adminToken", token);
  localStorage.setItem("userProfileRole", userProfileRole);
  localStorage.setItem("userProfileData", JSON.stringify(userProfileData));
  localStorage.setItem("brandProfileData", JSON.stringify(brandProfileData));
  localStorage.setItem("storeData", JSON.stringify(storeData));
  localStorage.setItem("warehouseData", JSON.stringify(warehouseData));
  localStorage.setItem(
    "garmentCategoryServiceIconsResData",
    JSON.stringify(garmentCategoryServiceIconsResData)
  );
};

export const getUserData = () => {
  const token = localStorage.getItem("adminToken");
  const userProfileRole = localStorage.getItem("userProfileRole");
  const userProfileData =
    JSON.parse(localStorage.getItem("userProfileData")) || {};
  const brandProfileData =
    JSON.parse(localStorage.getItem("brandProfileData")) || {};
  const storeData = JSON.parse(localStorage.getItem("storeData")) || {};
  const warehouseData = JSON.parse(localStorage.getItem("warehouseData")) || {};
  const garmentCategoryServiceIconsResData =
    JSON.parse(localStorage.getItem("garmentCategoryServiceIconsResData")) || {};

  return {
    token,
    userProfileRole,
    userProfileData,
    brandProfileData,
    storeData,
    warehouseData,
    garmentCategoryServiceIconsResData,
  };
  // return { token};
};

export const removeUserData = () => {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("userProfileRole");
  localStorage.removeItem("userProfileData");
  localStorage.removeItem("brandProfileData");
  localStorage.removeItem("storeData");
  localStorage.removeItem("warehouseData");
  localStorage.removeItem("garmentCategoryServiceIconsResData");

};

export const setSelectedSearchType = (
  searchType
) => {
  localStorage.setItem("searchType", searchType);

};

export const getSelectedSearchType = () => {
  const searchType = localStorage.getItem("searchType");
  return { searchType };
};

export const removeSelectedSearchType = () => {
  localStorage.removeItem("searchType");

};

// garment Remarks

export const setGarmentRemarks = (garmentRemarks) => {
   localStorage.setItem("garmentRemarks", JSON.stringify(garmentRemarks));
};

export const getGarmentRemarks = () => {
  const garmentRemarks =
    JSON.parse(localStorage.getItem("garmentRemarks")) || {};
  return { garmentRemarks };
};

export const removeGarmentRemarks = () => {
  localStorage.removeItem("garmentRemarks");
};

// service unit

export const setLocalServiceUnit = (serviceUnit) => {
  localStorage.setItem("serviceUnit", JSON.stringify(serviceUnit));
};

export const getLocalServiceUnit = () => {
  const serviceUnit = JSON.parse(localStorage.getItem("serviceUnit")) || [];
  return { serviceUnit };
};

export const removeLocalServiceUnit = () => {
  localStorage.removeItem("serviceUnit");
};


// app services

export const setLocalAppServices = (appServices) => {
  localStorage.setItem("appServices", JSON.stringify(appServices));
};

export const getLocalAppServices = () => {
  const appServices = JSON.parse(localStorage.getItem("appServices")) || [];
  return { appServices };
};

export const removeLocalAppServices = () => {
  localStorage.removeItem("appServices");
};

// price code

export const setLocalPriceCode = (priceCode) => {
  localStorage.setItem("priceCode", JSON.stringify(priceCode));
};

export const getLocalPriceCode = () => {
  const priceCode = JSON.parse(localStorage.getItem("priceCode")) || [];
  return { priceCode };
};

export const removeLocalPriceCode = () => {
  localStorage.removeItem("priceCode");
};

// package booking

export const setLocalPackageBooking = (packageBooking) => {
  localStorage.setItem("packageBooking", JSON.stringify(packageBooking));
};

export const getLocalPackageBooking = () => {
  const packageBooking =
    JSON.parse(localStorage.getItem("packageBooking")) || [];
  return { packageBooking };
};

export const removeLocalPackageBooking = () => {
  localStorage.removeItem("packageBooking");
};



export const setSelectedSearchOrderType = (
  searchOrderType
) => {
  localStorage.setItem("searchOrderType", searchOrderType);

};

export const getSelectedSearchOrderType = () => {
  const searchOrderType = localStorage.getItem("searchOrderType");
  return { searchOrderType };
};

export const removeSelectedSearchOrderType = () => {
  localStorage.removeItem("searchOrderType");

};


export const setSelectedInvoiceType = (
  invoiceType
) => {
  localStorage.setItem("invoiceType", invoiceType);

};

export const getSelectedInvoiceType = () => {
  const invoiceType = localStorage.getItem("invoiceType");
  return { invoiceType };
};

export const removeSelectedInvoiceType = () => {
  localStorage.removeItem("invoiceType");

};


export const setSelectedDocsSchedule = (docsSchedule) => {
  localStorage.setItem("docsSchedule", docsSchedule);
};

export const getSelectedDocsSchedule = () => {
  const docsSchedule = localStorage.getItem("docsSchedule");
  return { docsSchedule };
};

export const removeSelectedDocsSchedule = () => {
  localStorage.removeItem("docsSchedule");
};
;

export const setSelectedTabListView = (
  tabListView
) => {
  localStorage.setItem("tabListView", tabListView);

};

export const getSelectedTabListView = () => {
  const tabListView = localStorage.getItem("tabListView");
  return { tabListView };
};

export const removeSelectedTabListView = () => {
  localStorage.removeItem("tabListView");

};

export const setSelectedEWHChallanView = (
  eWHChallanView
) => {
  localStorage.setItem("eWHChallanView", eWHChallanView);

};

export const getSelectedEWHChallanView = () => {
  const eWHChallanView = localStorage.getItem("eWHChallanView");
  return { eWHChallanView };
};

export const removeSelectedEWHChallanView = () => {
  localStorage.removeItem("eWHChallanView");

};


export const setSelectedStoreChallanView = (
  storeChallanView
) => {
  localStorage.setItem("storeChallanView", storeChallanView);

};

export const getSelectedStoreChallanView = () => {
  const storeChallanView = localStorage.getItem("storeChallanView");
  return { storeChallanView };
};

export const removeSelectedStoreChallanView = () => {
  localStorage.removeItem("storeChallanView");

};

// invoice printer

export const setStoreInvoicePrinter = (
  invoicePrinter
) => {
  localStorage.setItem("invoicePrinter", invoicePrinter);

};

export const getStoreInvoicePrinter = () => {
  const invoicePrinter = localStorage.getItem("invoicePrinter");
  return { invoicePrinter };
};

export const removeStoreInvoicePrinter = () => {
  localStorage.removeItem("invoicePrinter");

};

// Tag printer

export const setStoreTagPrinter = (
  tagPrinter
) => {
  localStorage.setItem("tagPrinter", tagPrinter);

};

export const getStoreTagPrinter = () => {
  const tagPrinter = localStorage.getItem("tagPrinter");
  return { tagPrinter };
};

export const removeStoreTagPrinter = () => {
  localStorage.removeItem("tagPrinter");

};

// A4 & A5 printer


export const setStoreNormalA5A4Printer = (
  normalA5A4Printer
) => {
  localStorage.setItem("normalA5A4Printer", normalA5A4Printer);

};

export const getStoreNormalA5A4Printer = () => {
  const normalA5A4Printer = localStorage.getItem("normalA5A4Printer");
  return { normalA5A4Printer };
};

export const removeStoreNormalA5A4Printer = () => {
  localStorage.removeItem("normalA5A4Printer");

};


// garment Remarks Priority

export const setLocalGarmentRemarksPriority = (garmentRemarksPriority) => {
  localStorage.setItem(
    "garmentRemarksPriority",
    JSON.stringify(garmentRemarksPriority)
  );
};

export const getLocalGarmentRemarksPriority = () => {
  const garmentRemarksPriority =
    JSON.parse(localStorage.getItem("garmentRemarksPriority")) || {};
  return { garmentRemarksPriority };
};

export const removeLocalGarmentRemarksPriority = () => {
  localStorage.removeItem("garmentRemarksPriority");
};

// store Default Price

export const setLocalStoreDefaultPrice = (storeDefaultPrice) => {
  localStorage.setItem("storeDefaultPrice", JSON.stringify(storeDefaultPrice));
};

export const getLocalStoreDefaultPrice = () => {
  const storeDefaultPrice =
    JSON.parse(localStorage.getItem("storeDefaultPrice")) || [];
  return { storeDefaultPrice };
};

export const removeLocalStoreDefaultPrice = () => {
  localStorage.removeItem("storeDefaultPrice");
};



// payment mode

export const setLocalPaymentMode = (paymentMode) => {
  localStorage.setItem("paymentMode", JSON.stringify(paymentMode));
};

export const getLocalPaymentMode = () => {
  const paymentMode = JSON.parse(localStorage.getItem("paymentMode")) || [];
  return { paymentMode };
};

export const removeLocalPaymentMode = () => {
  localStorage.removeItem("paymentMode");
};

// Local Store Payment Gateway Config

export const setLocalStorePaymentGatewayConfig = (storePaymentGatewayConfig) => {
  localStorage.setItem(
    "storePaymentGatewayConfig",
    JSON.stringify(storePaymentGatewayConfig)
  );
};

export const getLocalStorePaymentGatewayConfig = () => {
  const storePaymentGatewayConfig =
    JSON.parse(localStorage.getItem("storePaymentGatewayConfig")) || [];
  return { storePaymentGatewayConfig };
};

export const removeLocalStorePaymentGatewayConfig = () => {
  localStorage.removeItem("storePaymentGatewayConfig");
};

// Local Charges And Discount

export const setLocalChargesAndDiscount = (chargesAndDiscount) => {
  localStorage.setItem(
    "chargesAndDiscount",
    JSON.stringify(chargesAndDiscount)
  );
};

export const getLocalChargesAndDiscount = () => {
  const chargesAndDiscount =
    JSON.parse(localStorage.getItem("chargesAndDiscount")) || [];
  return { chargesAndDiscount };
};

export const removeLocalChargesAndDiscount = () => {
  localStorage.removeItem("chargesAndDiscount");
};

// Franchise User Info

export const setLocalFranchiseUserInfo = (franchiseUser) => {
  localStorage.setItem("franchiseUser", JSON.stringify(franchiseUser));
};

export const getLocalFranchiseUserInfo = () => {
  const franchiseUser = JSON.parse(localStorage.getItem("franchiseUser")) || {};
  return { franchiseUser };
};

export const removeLocalFranchiseUserInfo = () => {
  localStorage.removeItem("franchiseUser");
};

// Franchise Store

export const setLocalFranchiseStore = (franchiseStore) => {
  localStorage.setItem("franchiseStore", JSON.stringify(franchiseStore));
};

export const getLocalFranchiseStore = () => {
  const franchiseStore =
    JSON.parse(localStorage.getItem("franchiseStore")) || [];
  return { franchiseStore };
};

export const removeLocalFranchiseStore = () => {
  localStorage.removeItem("franchiseStore");
};


// Franchise Info

export const setLocalFranchiseInfo = (franchiseInfo) => {
  localStorage.setItem("franchiseInfo", JSON.stringify(franchiseInfo));
};

export const getLocalFranchiseInfo = () => {
  const franchiseInfo =
    JSON.parse(localStorage.getItem("franchiseInfo")) || [];
  return { franchiseInfo };
};

export const removeLocalFranchiseInfo = () => {
  localStorage.removeItem("franchiseInfo");
};

// Franchise Rate

export const setLocalFranchiseRate = (franchiseRate) => {
  localStorage.setItem("franchiseRate", JSON.stringify(franchiseRate));
};

export const getLocalFranchiseRate = () => {
  const franchiseRate = JSON.parse(localStorage.getItem("franchiseRate")) || [];
  return { franchiseRate };
};

export const removeLocalFranchiseRate = () => {
  localStorage.removeItem("franchiseRate");
};



// admin selected Store

export const setLocalAdminSelectedStore = (adminSelectedStore) => {
  localStorage.setItem(
    "adminSelectedStore",
    JSON.stringify(adminSelectedStore)
  );
};

export const getLocalAdminSelectedStore = () => {
  const adminSelectedStore =
    JSON.parse(localStorage.getItem("adminSelectedStore")) || [];
  return { adminSelectedStore };
};

export const removeLocalAdminSelectedStore = () => {
  localStorage.removeItem("adminSelectedStore");
};

const PICKUP_API_INTERVAL = 15 * 1000; // 15 seconds
const PICKUP_TIMER_KEY = "nextPickupApiCallAt";

export const getNextPickupTime = () => {
  return Number(localStorage.getItem(PICKUP_TIMER_KEY));
};

export const setNextPickupTime = () => {
  const nextTime = Date.now() + PICKUP_API_INTERVAL;
  localStorage.setItem(PICKUP_TIMER_KEY, nextTime);
};

export const removeNextPickupTime = () => {
  localStorage.removeItem(PICKUP_TIMER_KEY);
};


// Pos Machine

export const setStorePOSEnabled = (
  storePOSEnabled
) => {
  // localStorage.setItem("storePOSEnabled", storePOSEnabled);
  localStorage.setItem("storePOSEnabled", JSON.stringify(storePOSEnabled));

};

export const getStorePOSEnabled = () => {
  const storePOSEnabled = localStorage.getItem("storePOSEnabled");
  return { storePOSEnabled };
};

export const removeStorePOSEnabled = () => {
  localStorage.removeItem("storePOSEnabled");

};



// Local Charges And Discount

export const setLocalGarmentPack = (garmentPack) => {
  localStorage.setItem(
    "garmentPack",
    JSON.stringify(garmentPack)
  );
};

export const getLocalGarmentPack = () => {
  const garmentPack =
    JSON.parse(localStorage.getItem("garmentPack")) || [];
  return { garmentPack };
};

export const removeLocalGarmentPack = () => {
  localStorage.removeItem("garmentPack");
};


// Pos invoice printer

export const setStorePOSInvoicePrinterValue = (
  invoicePrinterPOSValue
) => {
  localStorage.setItem("invoicePrinterPOSValue", invoicePrinterPOSValue);

};

export const getStorePOSInvoicePrinterValue = () => {
  const invoicePrinterPOSValue = localStorage.getItem("invoicePrinterPOSValue");
  return { invoicePrinterPOSValue };
};

export const removeStorePOSInvoicePrinterValue = () => {
  localStorage.removeItem("invoicePrinterPOSValue");

};

// Pos Tag printer

export const setStorePOSTagPrinterValue = (
  tagPrinterPOSValue
) => {
  localStorage.setItem("tagPrinterPOSValue", tagPrinterPOSValue);

};

export const getStorePOSTagPrinterValue = () => {
  const tagPrinterPOSValue = localStorage.getItem("tagPrinterPOSValue");
  return { tagPrinterPOSValue };
};

export const removeStorePOSTagPrinterValue = () => {
  localStorage.removeItem("tagPrinterPOSValue");

};



// Pos invoice printer Receipt Type

export const setStorePOSInvoicePrinterReceiptType = (
  invoicePrinterPOSReceiptTypeValue
) => {
  localStorage.setItem("invoicePrinterPOSReceiptTypeValue", invoicePrinterPOSReceiptTypeValue);

};

export const getStorePOSInvoicePrinterReceiptType = () => {
  const invoicePrinterPOSReceiptTypeValue = localStorage.getItem("invoicePrinterPOSReceiptTypeValue");
  return { invoicePrinterPOSReceiptTypeValue };
};

export const removeStorePOSInvoicePrinterReceiptType = () => {
  localStorage.removeItem("invoicePrinterPOSReceiptTypeValue");

};


export const setSelectedTabListPickupView = (
  tabListPickupView
) => {
  localStorage.setItem("tabListPickupView", tabListPickupView);

};

export const getSelectedTabListPickupView = () => {
  const tabListPickupView = localStorage.getItem("tabListPickupView");
  return { tabListPickupView };
};

export const removeSelectedTabListPickupView = () => {
  localStorage.removeItem("tabListPickupView");

};




export const setStoreLocalData = (storeLocalData) => {
  localStorage.setItem("storeLocalData", JSON.stringify(storeLocalData));
};

export const getStoreLocalData = () => {
  const storeLocalData =
    JSON.parse(localStorage.getItem("storeLocalData")) || {};
  return { storeLocalData };
};

export const removeStoreLocalData = () => {
  localStorage.removeItem("storeLocalData");
};


export const removeHostProfile = () => {
  localStorage.removeItem("hostProfile");
};
